import { formatTime as formatTimeDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type FormatTimeProps = {
    duration: number;
}

export const formatTime = ({ duration }: FormatTimeProps): string =>
    formatTimeDiagram(duration);
